// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Recording_phoneNumber__mOwcD {
  font-size: 0.925rem;
}
@media screen and (min-width: 75em) {
  .Recording_phoneNumber__mOwcD {
    font-size: 1rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/reporting/%5Bid%5D/Recording/index.module.scss","webpack://./src/pages/reporting/[id]/Recording/index.module.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;ACCF;ADCE;EAHF;IAII,eAAA;ECEF;AACF","sourcesContent":[".phoneNumber {\n  font-size: 0.925rem;\n\n  @media screen and (min-width: 75em) {\n    font-size: 1rem;\n  }\n}\n",".phoneNumber {\n  font-size: 0.925rem;\n}\n@media screen and (min-width: 75em) {\n  .phoneNumber {\n    font-size: 1rem;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"phoneNumber": `Recording_phoneNumber__mOwcD`
};
export default ___CSS_LOADER_EXPORT___;
